export const PROJECT_ROLES = ['guest', 'member', 'admin', 'owner'];
/** Returns true when `role` is at least `min` in the owner > admin > member > guest order. */
export function roleAtLeast(role, min) {
    return PROJECT_ROLES.indexOf(role) >= PROJECT_ROLES.indexOf(min);
}
export const ROOM_KINDS = ['shared', 'private'];
//# sourceMappingURL=roles.js.map